export enum BoosterStatus {
  Active = "active",
  Available = "available",
  ExpiredActive = "expired_active",
  ExpiredAvailable = "expired_available",
}

export interface Booster {
  boosterId: string;
  factor: string | number;
  duration: string | number;
  expiredTime: string;
  gameId: string;
  boosterGame?: {
    name: string;
  };
}

export interface BoosterApi {
  boosterId: string;
  expireAt: string;
  gameId: string;
  multiplier: number;
  name: string;
  status: BoosterStatus;
}

export interface BoosterBackend {
  id: string;
  name: string;
  multiplier: number;
  actionTime: number;
  activationTime: number;
  createdAt: string;
  gameId: string;
  maxExperience: number;
  updatedAt: string;
}
